const proofItems = [
  { icon: "ri-calendar-check-line", value: "1991", label: "Year Founded", sub: "Over 33 years in operation" },
  { icon: "ri-government-line", value: "2", label: "Municipal Contracts", sub: "Riverside & Moreno Valley" },
  { icon: "ri-car-line", value: "300+", label: "Vehicle Capacity", sub: "Secure impound facilities" },
  { icon: "ri-time-line", value: "24/7", label: "Always Available", sub: "365 days a year" },
];

export default function CredibilityProof() {
  return (
    <section className="bg-[#0d0d0f] py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">Proven Track Record</span>
            <div className="w-8 h-px bg-[#D4AF37]"></div>
          </div>
          <h2 className="text-white font-black text-4xl md:text-5xl mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Built on Decades of Trust
          </h2>
          <p className="text-[#888] text-base max-w-xl mx-auto">
            Exclusive Recovery Inc has earned its position as a trusted towing and recovery authority through consistent performance, institutional partnerships, and community presence since 1991.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {proofItems.map((item, i) => (
            <div key={i} className="bg-[#1a1a1c] border border-[#2a2a2c] rounded-lg p-6 text-center hover:border-[#D4AF37]/30 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${item.icon} text-[#D4AF37] text-2xl`}></i>
              </div>
              <div className="text-white font-black text-3xl mb-1" style={{ fontFamily: "'Outfit', sans-serif" }}>{item.value}</div>
              <div className="text-white font-semibold text-sm mb-1">{item.label}</div>
              <div className="text-[#666] text-xs">{item.sub}</div>
            </div>
          ))}
        </div>

        {/* Institutional trust strip */}
        <div className="border border-[#2a2a2c] rounded-lg p-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-sm shrink-0">
              <i className="ri-shield-star-line text-[#D4AF37] text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-base">Trusted by Law Enforcement & Municipalities</p>
              <p className="text-[#888] text-sm">Active contracts with the City of Riverside, City of Moreno Valley, and state and local law enforcement agencies throughout Southern California.</p>
            </div>
          </div>
          <a href="tel:9516822003" className="shrink-0 bg-[#D4AF37] text-black font-bold px-6 py-3 rounded-sm tracking-wider uppercase text-sm hover:bg-[#c49f27] transition-colors cursor-pointer whitespace-nowrap">
            Call (951) 682-2003
          </a>
        </div>
      </div>
    </section>
  );
}
